import { TipoLocalitaEstera1 } from 'server/schema/integrations/pdnd/schema/schemas';

export function getCitizenConsolate(
  foreignLocation?: TipoLocalitaEstera1
): string | undefined {
  if (!foreignLocation?.consolato) {
    return undefined;
  }
  return (
    (foreignLocation?.consolato?.descrizioneConsolato ?? '') +
    ' ' +
    (foreignLocation?.consolato?.codiceConsolato ?? '')
  );
}
